import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const editModalUsersSlice = createSlice({
  name: "editModalUsers",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModal, closeModal } = editModalUsersSlice.actions;

export default editModalUsersSlice.reducer;